import template from './metadata_inputs.html'
import './metadata_inputs.css'

export default {
  template,
  controller: 'metadataInputsController as metadataInputs'
}
